<template>
  <div class="images" v-show="options.show">
    <!-- swiper1 -->
    <swiper :options="swiperOptionTop" class="gallery-top" ref="mySwiper">
      <swiper-slide v-for="(item,i) in options.list" :key="i">
        <div class="border_wai">
          <div class="img_border">
            <img :src="item.detail_img" />
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!-- 箭头放在外面 -->
    <div class="swiper-button-next swiper-button-white swiper-button-next-false1" slot="button-next"></div>
    <div class="swiper-button-prev swiper-button-white swiper-button-prev-false1" slot="button-prev"></div>
    <div class="close_btn" @click="close"></div>
  </div>
</template>
<script>
export default {
  name: "tx-image-template",
  props: {
    //接收图片资源
    options: {
      type: Object,
      default() {
        return {
          list: {
            type: Array,
            default: []
          },
          show: {
            type: Boolean,
            default: false
          }
        };
      }
    },
    toIndex: ""
  },
  data() {
    const self = this;
    return {
      index: 0,
      //大图控件
      swiperOptionTop: {
        // effect:'fade',
        // spaceBetween: 10,
        loop: false,
        loopedSlides: 5, //looped slides should be the same
        grabCursor: true, //允许手抓滑动
        navigation: {
          nextEl: ".swiper-button-next-false1",
          prevEl: ".swiper-button-prev-false1"
        },
        on: {
          slideChangeTransitionEnd: function() {
            self.index = this.realIndex;
          }
        }
      }
    };
  },
  components: {},
  mounted() {},
  methods: {
    //关闭
    close() {
      this.options.show = false;
      this.$emit("close", 99);
      this.$emit("close", this.index);
    }
  },
  watch: {
    toIndex(newValue, oldValue) {
      this.index = newValue;
      this.$refs.mySwiper.swiper.slideTo(newValue, 500, false);
    }
  }
};
</script>
<style lang="scss" scoped>
.images {
  height: 100%;
  position: relative;
  .close_btn {
    width: 40px;
    height: 40px;
    background: url("//txwl.huohuoche.com/txws/new_images_one/close.png")
      no-repeat center;
    background-size: cover;
    position: absolute;
    top: 1%;
    right: 5%;
    cursor: pointer;
    z-index: 999;
  }
  .swiper-container {
    background-color: #000;
    z-index: 999;
  }
  .swiper-slide {
    background-size: cover;
    background-position: center;
    border-radius: 4px;
    height: 100% !important;
  }
  .gallery-top {
    width: 80% !important;
    height: 100% !important;
    margin-top: 0% !important;
    border-radius: 4px;
    // border: 1px solid #997e2c;
    .border_wai {
      width: 100%;
      height: 100%;
      // border:1px solid red;
      margin-left: -0.5%;
      overflow: hidden;
      .img_border {
        width: 100%;
        height: 100%;
        overflow: auto;
        // border:1px solid blue;
        margin-left: 1%;
        img {
          width: 100%;
        }
      }
      .img_border::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .swiper-button-prev-false1 {
    position: absolute;
    left: 6%;
    top: 46%;
  }
  .swiper-button-next-false1 {
    position: absolute;
    right: 6%;
    top: 46%;
  }

  .swiper-button-prev-false1:focus,
  .swiper-button-next-false1:focus {
    outline: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/common/tx-img-template.vue